import graphql__b236216993c15f02938a from "./__generated__/useSidebarSectionTitle_pageSection.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { hasHtmlContent } from "../Utils/htmlStringUtils";
import Icon from "../Utils/Icon";

export const useSidebarSectionTitle = props => {
  const pageSection = useFragment(useSidebarSectionTitle_pageSection, props.pageSection);
  const { iconClass, title: sectionTitle } = pageSection;

  const iconClassName = classNames(["text-primary", iconClass]);

  const icon = useMemo(
    () => iconClass && <Icon className={iconClassName} />,
    [iconClass, iconClassName]
  );

  const titleContainer = useMemo(() => {
    if (!hasHtmlContent(sectionTitle)) return null;

    const className = classNames("card-header", "padding-md", "text-subtitle-page", {
      "with-icon": icon
    });

    const textClassName = classNames("padding-top-none", "text-subtitle-page", {
      "with-icon-text": icon
    });

    return (
      <div className={className}>
        {icon}

        <h2 className={textClassName}>{sectionTitle}</h2>
      </div>
    );
  }, [sectionTitle, icon]);

  return { title: titleContainer };
};

const useSidebarSectionTitle_pageSection = graphql__b236216993c15f02938a;
